export default "__VITE_ASSET__C52AB8e___"